import httpClient from "@/api/config";

const resetDefaultState = () => ({
	name: undefined,
	description: undefined,
	keywords: [],
	industry_uuid: undefined,
	pages: [],
	assignedUser: [],
	monitorType: "keyword"
});

export default {
	namespaced: true,

	state: {
		generalSectionInvalid: true,
		keywordSectionInvalid: true,
		sourceSectionInvalid: true,
		industries: [],
		sources: [],
		users: [],
		monitorFetchReady: false,
		industry_uuid: undefined,
		name: undefined,
		description: undefined,
		keywords: [],
		pages: [],
		owner: undefined,
		assignedUser: [],
		fetchIndustryReady: false,
		fetchSourcesReady: false,
		monitorType: "keyword",
		monitorListSearchString:undefined,
		searchMonitorListByOrganization:undefined
	},

	actions: {

		fetchIndustries({commit}) {
			return httpClient.get(`/v2/industry`)
				.then(({data}) => {
					commit('setIndustries', data)
				})
		},

		fetchSources({commit}) {
			return httpClient.get(`/crawl-list`)
				.then(({data}) => {
					commit('setSources', data)
				})

		},

		fetchUsers(context, page) {
			return httpClient.get(`/v2/user`, {
				params: {page}
			}).then(({data}) => {
				return data
			})
		},

		createMonitor(context, data) {
			return httpClient.post(`/v2/monitor`, data)
		},

		updateMonitor(context, {data, monitor_uuid}) {
			return httpClient.put(`/v2/monitor/${monitor_uuid}`, data)
		},

		deleteMonitor(context, monitor_uuid) {
			return httpClient.delete(`/v2/monitor/${monitor_uuid}`)
		},

		getUserByEmail(context, email) {
			return httpClient.get(`/v2/user/check/${email}`)
		},

		getUsersWithAccessToMonitor(context, monitor_uuid) {
			return httpClient.get(`/v2/monitor/${monitor_uuid}/users`)
		},

		updateUserMonitorAccess(context, {monitor_uuid, monitor_access}) {
			return httpClient.put(`/v2/monitor/${monitor_uuid}/monitor-access`, {monitor_access})
		},

		removeUserMonitorAccess(context, {monitor_uuid, user_uuid}) {
			return httpClient.delete(`/v2/monitor/${monitor_uuid}/users/${user_uuid}`)
		}

	},

	mutations: {
		setIndustries(state, {industries}) {
			state.industries.push(...industries)
		},

		setSources(state, {facebookpages}) {
			state.sources = facebookpages
		},

		setUsers(state, users) {
			state.users = users
		},

		setMonitorName(state, name) {
			state.name = name
		},

		setMonitorIndustry(state, industry) {
			state.industry_uuid = industry
		},

		setMonitorDescription(state, description) {

			state.description = description
		},

		setMonitorKeywords(state, keywords) {

			state.keywords = keywords
		},

		setMonitorSources(state, source) {

			state.pages = source
		},

		setMonitorOwner(state, owner) {

			state.owner = owner
		},

		setReady(state, value) {
			state.monitorFetchReady = value
		},

		assignUserToMonitor(state, users) {

			state.assignedUser = users
		},

		setGeneralSectionValidation(state, status) {
			state.generalSectionInvalid = status
		},

		setKeywordSectionValidation(state, status) {
			state.keywordSectionInvalid = status
		},

		setSourceSectionValidation(state, status) {
			state.sourceSectionInvalid = status
		},

		setDefaultState(state) {
			Object.assign(state, resetDefaultState())
		},

		setFetchIndustryReady(state, status) {
			state.fetchIndustryReady = status;
		},

		setFetchSourcesReady(state, status) {
			state.fetchSourcesReady = status;
		},

		setMonitorType(state, type) {
			state.monitorType = type
		},

		setMonitorListSearchString(state, searchText) {
			state.monitorListSearchString = searchText;
		},

		setSearchMonitorListByOrganization(state, organization){
			state.searchMonitorListByOrganization = organization;
		}

	},

	getters: {
		hIndustries(state) {
			return state.industries.map(industry => ({
				_id: industry["_id"],
				name: industry.display_name,
				uuid: industry.uuid
			}))
		}
	}

}
